import { gql } from '@apollo/client';

export default gql`
  mutation createItem(
    $branch: String
    $itemType: Int
    $barcode: String
    $disabled: Boolean
    $additionId: String
    $name: String
    $nameAr: String
    $desc: String
    $photo: String
    $cost: Float
    $price: Float
    $unit: String
    $qty: Float
    $rentitemcost: Float
    $yeardepreciation: Float
    $rentdepreciation: Float
    $purchaseDate: Date
    $subitems: String
    $isSalary: Boolean
    $category: CategoryInput
    $brand: BrandInput
    $employee: EmployeeInput
    $resourse: ResourseInput
    $department: DepartmentInput
  ) {
    createItem(
      branch: $branch
      itemType: $itemType
      barcode: $barcode
      disabled: $disabled
      additionId: $additionId
      name: $name
      nameAr: $nameAr
      desc: $desc
      photo: $photo
      cost: $cost
      price: $price
      unit: $unit
      qty: $qty
      rentitemcost: $rentitemcost
      yeardepreciation: $yeardepreciation
      rentdepreciation: $rentdepreciation
      purchaseDate: $purchaseDate
      subitems: $subitems
      category: $category
      brand: $brand
      isSalary: $isSalary
      employee: $employee
      resourse: $resourse
      department: $department
    ) {
      ok
      message
      data
      error
    }
  }
`;
